<template>
  <div id="app" class="app-body" v-if="success">
    <dashboard v-if="!showSettings" :panelId="panelId" :password="password" :baseUrl="baseUrl" />
    <settings v-if="showSettings" :panelId="panelId" :password="password" :adminpassword="adminpassword" :baseUrl="baseUrl"/>
  </div>
</template>

<script>
import Dashboard from './components/dashboard';
import Settings from './components/settings';
import bent from 'bent';


export default {
  name: 'App',
  components: {
    Dashboard,
    Settings,
  },
  data() {
    return {
      //baseUrl: 'http://localhost:3001/products/products.panels/',
      baseUrl: 'https://clients.amoapi.ru/products/products.panels/',
      post: null,
      success: false,
      showSettings: false,
      panelId: null,
      password: null,
      adminpassword: null,
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    document.title = 'Panel - SimpleSales';
    const urlParams = new URLSearchParams(window.location.search);
    this.panelId = urlParams.get('c');
    this.password = urlParams.get('p');
    try {
      const check = await this.post('login', {
        panelId: this.panelId,
        password: this.password,
      });
      if (check.success) {
        this.success = true;
      }
    } catch (error) {
      alert('Неправильные параметры входа');
    }

    this._keyListener = async function(e) {
      if (e.key === 'i' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault(); 
        if (!this.showSettings) {
          const adminpassword = prompt('Введите пароль администратора панели');
          try {
            const check = await this.post('adminlogin', {
              panelId: this.panelId,
              password: this.password,
              adminpassword: adminpassword,
            });
            if (check.success) {
              this.adminpassword = adminpassword
              this.showSettings = true;
            } else {
              alert('Неверный пароль');
            }
          } catch (error) {
            alert('Неверный пароль');
          }
        } else {
          this.showSettings = false;
        }
      }
    };

    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },
};
</script>

<style lang="sass">

@font-face
  font-family: 'evolventa'
  src: local('evolventa')
  src: url("assets/fonts/evolventa.woff2") format('woff2'), url("assets/fonts/evolventa.ttf") format('TrueType')
  font-weight: normal

@font-face
  font-family: 'evolventa'
  src: local('evolventa')
  src: url("assets/fonts/evolventa-bold.woff2") format('woff2'), url("assets/fonts/evolventa-bold.ttf") format('TrueType')
  font-weight: bold

body
  font-family: 'evolventa', sans-serif

*,
*::before,
*::after
  box-sizing: border-box

*:focus
  outline: none

body
  margin: 0
  padding: 0

.app-body
  background: #05051E
  min-height: 100vh
</style>
